"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function loadScript(src) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    async: false,
    defer: false
  };
  var scriptElement = document.createElement('script');
  scriptElement.type = 'text/javascript';
  scriptElement.async = params.async;
  scriptElement.defer = params.defer;
  scriptElement.src = src;
  return new Promise(function (resolve, reject) {
    scriptElement.onload = function () {
      resolve(true);
    };
    scriptElement.onerror = reject;
    document.head.appendChild(scriptElement);
  });
}
var _default = loadScript;
exports["default"] = _default;